<template>
    <div>

        <app-bar :menu="appMenu"
                 @addToMenu="_addToMenu"
        ></app-bar>

        <div class="map elevation-5" id="map"></div>

        <v-bottom-sheet persistent hide-overlay v-model="openDetails" close-delay="2000" v-touch="{down: closeDetail}">
            <v-sheet class="text-center" height="auto">
                <div class="py-3">
                    <v-avatar @click="openClub(details.container_id)" style="margin-top: -60px" color="#f7f7f7" size="120" class="elevation-8 mb-5">
                        <v-img class="pa-0 border" :alt="details.name" :src="details.icon">
                            <template v-slot:placeholder>
                                <v-progress-circular class="ma-10" width="2" indeterminate></v-progress-circular>
                            </template>
                        </v-img>
                    </v-avatar>
                    <h3>{{details.name}}</h3>
                    <v-container class="pb-0 mb-0">
                        <v-row>
                            <v-col>
                                <v-icon size="35">mdi-account-group</v-icon>
                                <span class="d-block title font-weight-light">Membri<br><strong>{{details.members}}</strong></span>
                            </v-col>
                            <v-divider vertical></v-divider>
                            <v-col>
                                <v-icon size="35">mdi-map-search</v-icon>
                                <span class="d-block title font-weight-light">Provincia di<br><strong>{{details.province}}</strong></span>
                            </v-col>
                            <v-col cols="12" class="ma-0 pa-0">
                                <v-btn color="#999" fab @click="closeDetail" rounded outlined>
                                    <v-icon color="#ad2c2b">mdi-close</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </div>
            </v-sheet>
        </v-bottom-sheet>
    </div>
</template>

<script>
    import axios from 'axios';
    import "leaflet/dist/leaflet.css";
    import L from "leaflet";
    import {mapActions} from 'vuex'

    export default {
        name: 'ClubMap',
        data() {
            return {
                openDetails: false,
                details: {},
                map: {},
                MAP_LINK: 'https://api.maptiler.com/maps/toner/{z}/{x}/{y}@2x.png?key=' + this.$store.state.MAP_KEY,
                ISIcon: {
                    iconUrl: 'https://www.italiasoftair.it/images/assets/map-marker.png',
                    shadowUrl: 'https://www.italiasoftair.it/images/assets/map-marker-shadow.png',
                    iconSize: [45, 60],
                    shadowSize: [60, 63],
                    iconAnchor: [22, 63],
                    shadowAnchor: [15, 66],
                    popupAnchor: [0, -40]
                },
                appMenu: [
                    {text: 'Aggiungi al Menù', icon: 'mdi-pin', action: 'addToMenu'},
                ],
            }
        },
        mounted() {
            setTimeout(() => {
                this.loadMap();
                let mapdiv = document.getElementById("map");
                let height = window.innerHeight;
                mapdiv.style.height = (height-80) + 'px';
            }, 100);
        },
        methods: {
            ...mapActions([
                '_addToMenu'
            ]),
            loadMap() {
                axios
                    .get(this.$store.state.ROOT_API + '/club/map', {
                        headers: {
                            'Authorization': 'Bearer ' + this.$store.getters.getToken
                        }
                    })
                    .then(resp => {
                        this.map = resp.data.map;
                        setTimeout(() => {
                            this.initMap()
                        }, 100);
                    })
                    .catch((error) => {
                        console.error(error)
                    })
            },
            initMap() {

                let _this = this;
                const mapboxTiles = L.tileLayer(this.MAP_LINK, {
                    tileSize: 512,
                    zoomOffset: -1,
                    minZoom: 1,
                    attribution: '<a href="https://cartiqo.nl/" target="_blank">© Cartiqo</a> <a href="https://www.maptiler.com/copyright/" target="_blank">© MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">© OpenStreetMap contributors</a>',
                    crossOrigin: true
                });
                const map = L.map('map', {
                    center: [42.6384261, 12.674297],
                    zoom: 5.5,
                    scrollWheelZoom: false
                }).addLayer(mapboxTiles);

                let club_markers = this.map;
                club_markers.forEach(function (item, index) {
                    let marker = new L.marker([item.lat, item.lng], {icon: L.icon(_this.ISIcon)}).on('click', function () {
                        _this.openDetail(item);
                    }).addTo(map);
                });
                map.doubleClickZoom.disable();

                if (navigator.geolocation) {
                    this.ISIcon.iconUrl = this.$store.state.ROOT + '/images/assets/map-marker-me.png';
                    navigator.geolocation.getCurrentPosition(function (pos) {
                        let geo = pos.coords;
                        let me = L.marker([geo.latitude , geo.longitude],{icon: L.icon(_this.ISIcon)}).addTo(map).bindPopup('Sono qui!').openPopup();
                        map.flyTo(me.getLatLng(),10);
                    }, function (err) {
                        console.warn(`ERROR(${err.code}): ${err.message}`);
                    }, {
                        enableHighAccuracy: true,
                        timeout: 5000,
                        maximumAge: 0
                    });
                } else {
                    console.warn('Geolocation is not supported by this browser.');
                }

            },

            openDetail(item) {
                console.log(item)
                setTimeout(() => {
                    this.details = item;
                    this.openDetails = true;
                    this.items=[];
                }, 100);
            },

            openClub(id) {
                this.$router.push({
                    name: 'club',
                    params: {club_id: id, back_to: this.$route}
                })
            },

            closeDetail() {
                this.openDetails = false;
                setTimeout(() => {
                    this.details = {};
                }, 500);
            },
        },

    }
</script>

<style scoped>
    .map {
        width: 100%;
        background-color: #333;
        margin: 0;
        padding: 0;
        min-height: 20px;
        z-index: 1;
    }
</style>